<div [ngClass]="componentClasses">
  <app-header></app-header>
  <div class="app-component__content-wrapper">
    <div
      class="app-component__sidebar-container"
      *ngIf="(userSignedIn$ | async) && !isWrapperlessPage">
      <div
        class="sidenav-background"
        (click)="onBackgroundClick()"></div>
      <sidenav-content></sidenav-content>
    </div>
    <div class="app-component__content-container">
      <toast></toast>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
